import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function currentPositionReducer(
    state = initialState.currentPosition,
    action: CurrentMentorsActions
): Position | null {
    switch (action.type) {
        case types.POSITION_UPDATED:
            return action.position;
        default:
            return state;
    }
}
